import type { DocumentWithSummary, IdToDocumentMap } from '../../types';

// Modifies input
export default function trimDocumentsSummary(docs?: IdToDocumentMap | null) {
  if (!docs) {
    return;
  }

  for (const docId of Object.keys(docs)) {
    // Explanation: IdToDocumentMap values are AnyDocument; DocumentWithSummary is a narrower shape we know docs can have
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    const doc = docs[docId] as DocumentWithSummary;
    const currentSummary = doc.summary;
    if (currentSummary) {
      doc.summary = currentSummary.substring(0, 1024);
    }
  }
}
